export const DEFAULT_COUNTRY_CODE = {
	PL: 'PL'
};
